import { Button, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
export const Pagination = ({
  page,
  totalPages,
  totalEmployees,
  limit,
  onPageChange,
}) => {
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  if (totalPages <= 1) return null;
    const getPageNumbers = () => {
    let start = Math.max(1, Math.min(totalPages - 4, page - 2));
    start = Math.min(start, Math.max(1, totalPages - 4));
    return Array.from({ length: Math.min(5, totalPages) }, (_, i) => start + i)
      .filter((num) => num >= 1 && num <= totalPages);
  };
  return (
    // <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
    //   <div className="text-sm text-base-content/70">
    //     Showing {(page - 1) * limit + 1} to{' '}
    //     {Math.min(page * limit, totalEmployees)} of {totalEmployees} employees
    //   </div>
    //   <div className="join">
    //     <button
    //       className="join-item btn btn-sm"
    //       onClick={() => handlePageChange(page - 1)}
    //       disabled={page === 1}
    //     >
    //       <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         className="h-4 w-4"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         stroke="currentColor"
    //       >
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           strokeWidth="2"
    //           d="M15 19l-7-7 7-7"
    //         />
    //       </svg>
    //     </button>

    //     {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
    //       const pageNum = Math.max(1, Math.min(totalPages - 4, page - 2)) + i;
    //       return pageNum <= totalPages ? (
    //         <button
    //           key={pageNum}
    //           className={`join-item btn btn-sm ${
    //             page === pageNum ? 'btn-active' : ''
    //           }`}
    //           onClick={() => handlePageChange(pageNum)}
    //         >
    //           {pageNum}
    //         </button>
    //       ) : null;
    //     })}

    //     <button
    //       className="join-item btn btn-sm"
    //       onClick={() => handlePageChange(page + 1)}
    //       disabled={page === totalPages}
    //     >
    //       <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         className="h-4 w-4"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         stroke="currentColor"
    //       >
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           strokeWidth="2"
    //           d="M9 5l7 7-7 7"
    //         />
    //       </svg>
    //     </button>
    //   </div>
    // </div>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      mt={4}
    >
      <Typography variant="body2" color="text.secondary">
        Showing {(page - 1) * limit + 1} to{' '}
        {Math.min(page * limit, totalEmployees)} of {totalEmployees} employees
      </Typography>
      <Stack direction="row" spacing={1}>
        <IconButton
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          size="small"
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>

        {getPageNumbers().map((pageNum) => (
          <Button
            key={pageNum}
            variant={page === pageNum ? 'contained' : 'outlined'}
            color={page === pageNum ? 'primary' : 'inherit'}
            size="small"
            onClick={() => handlePageChange(pageNum)}
            sx={{
              minWidth: 36,
              px: 1.5,
              ...(page === pageNum && { fontWeight: 'bold' }),
            }}
          >
            {pageNum}
          </Button>
        ))}

        <IconButton
          onClick={() => handlePageChange(page + 1)}
          disabled={page === totalPages}
          size="small"
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
};
